import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: '"I\'m not a technical person. Is this for me?"',
  a: 'Absolutely. This is built for Managers and Creatives, not coders. If you can send an email, you can use these frameworks.'
}, {
  q: '"Is this just another list of ChatGPT prompts?"',
  a: "No. It's a career strategy. Prompt lists expire; strategic frameworks are permanent. We teach you how to think in the AI age."
}, {
  q: '"How long will this take to implement?"',
  a: 'You will reclaim your first 2 hours within the first 48 hours of reading the "Action Plan" section.'
}];
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 sm:py-32 px-4 bg-white" data-id="element-17">
      <div className="max-w-3xl mx-auto" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-19">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-brand-dark mb-4" data-id="element-20">
            Frequently Asked Questions
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-21">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="border border-brand-dark/10 rounded-sm overflow-hidden" data-id="element-22">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-6 text-left bg-brand-light hover:bg-brand-dark/5 transition-colors" data-id="element-23">
                  <span className="font-bold text-brand-dark text-lg pr-8" data-id="element-24">
                    {faq.q}
                  </span>
                  {isOpen ? <Minus className="w-5 h-5 text-brand-accent shrink-0" data-id="element-25" /> : <Plus className="w-5 h-5 text-brand-accent shrink-0" data-id="element-26" />}
                </button>
                <AnimatePresence data-id="element-27">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-28">
                      <div className="p-6 pt-0 bg-brand-light text-brand-dark/80 leading-relaxed border-t border-brand-dark/5" data-id="element-29">
                        <span className="font-bold text-green-600 mr-2" data-id="element-30">✓</span>
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
};